import React, { useEffect, useRef } from "react";
import "./Hero.css";
import { heroContent } from "../../data/content";

const Hero = () => {
  const heroRef = useRef(null);

  // Parallax بسيط للتيكست
  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;

    const onScroll = () => {
      const y = window.scrollY;
      el.style.setProperty("--parallax", `${Math.min(y * 0.12, 30)}px`);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section id="introduction" className="hero">
      <div className="hero-overlay" />

      <div className="hero-content">
        <h1 ref={heroRef} className="hero-title">
          {heroContent.titleLine1}
          <span className="hero-title-small">{heroContent.titleLine2}</span>
          {heroContent.titleLine3}
        </h1>
      </div>
    </section>
  );
};

export default Hero;